import { render, staticRenderFns } from "./UpdateProducerCommissionDialog.vue?vue&type=template&id=1d7662cf&scoped=true"
import script from "./UpdateProducerCommissionDialog.vue?vue&type=script&lang=js"
export * from "./UpdateProducerCommissionDialog.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1d7662cf",
  null
  
)

export default component.exports